import React from 'react';
import { Box, Button, Typography, useTheme } from '@mui/material';
import { dossierValidatorsSelector, FormalityValidator } from '@europrocurement/l2d-domain';
import { useSelector } from 'react-redux';
import { FlexyForm, FormStructure } from '@europrocurement/flexy-form';
import { useForm } from 'react-hook-form';

type ShowValidatorModalProps = {
    formalityValidator: FormalityValidator;
    onSubmit: (validator: FormalityValidator) => void;
    onCancel: () => void;
};

type ValidatorFormData = {
    default: boolean;
};

const ShowValidatorModal: React.FunctionComponent<ShowValidatorModalProps> = function (props) {
    const { formalityValidator, onSubmit, onCancel } = props;
    const { palette } = useTheme();
    const dataSource = useSelector(dossierValidatorsSelector);
    const validator = dataSource.data.find(
        (v) => (v.id as unknown as number) === formalityValidator.validator,
    );

    const formStructure: FormStructure[] = [
        {
            type: 'boolean',
            name: 'default',
            inputlabel: 'Valideur par défaut',
        },
    ];

    const formContext = useForm<ValidatorFormData>({
        mode: 'onTouched',
        defaultValues: {
            default: formalityValidator.default,
        },
    });

    const handleSubmit = (data: ValidatorFormData) => {
        onSubmit({
            ...formalityValidator,
            ...data,
        });
    };

    const formProps = {
        formContext,
        formObject: {},
        onSubmit: handleSubmit,
        submitButton: {
            displayed: false,
        },
    };

    return (
        <Box sx={{ width: '450px', display: 'flex', flexDirection: 'column', gap: '16px 0' }}>
            <Typography variant="l2dh6">Valideur {validator?.label}</Typography>
            <FlexyForm
                formStructure={formStructure}
                {...formProps}
            />
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button
                    variant="text"
                    onClick={onCancel}
                    sx={{ color: palette.primary.dark }}
                >
                    Annuler
                </Button>
                <Button
                    variant="contained"
                    onClick={formContext.handleSubmit(handleSubmit)}
                    sx={{ padding: '16px 24px', background: palette.primary.dark }}
                >
                    Confirmer
                </Button>
            </Box>
        </Box>
    );
};

export default ShowValidatorModal;
